{
  "list": {
    "content": {
      "orderService": "Obsługa",
      "id": "ID",
      "guaranteeNumber": "Numer gwarancji",
      "status": "Status",
      "type": "Typ",
      "beneficiaryName": "Beneficjent",
      "currency": "Waluta",
      "guaranteeCurrencyName": "Waluta",
      "guaranteeAmount": "Kwota",
      "effectiveDate": "Data wystawienia",
      "expirationDate": "Data ważności",
      "formTemplateName": "Rodzaj gwarancji",
      "enFormTemplateName": "Rodzaj gwarancji",
      "lastModifiedDate": "Data modyfikacji",
      "creditLineExceeded": "Przekroczone warunki linii",
      "childNumber": "Numer zmiany"
    },
    "buttons": {
      "new": "Nowe zlecenie",
      "order": "Podgląd zlecenia",
      "copy": {
        "name": "Kopiuj zlecenie",
        "tooltip": "Złóż nowe zlecenie wykorzystując jako wzór zlecenie zrealizowane"
      }
    }
  },
  "details": {
    "basicInfo": {
      "client": "Klient",
      "clientCis": "CIS",
      "guaranteeNumber": "Nr gwarancji",
      "guaranteeAccountNumber": "Numer rachunku gwarancji",
      "id": "ID",
      "lastModifiedDate": "Data ostatniej modyfikacji",
      "operator": "Operator",
      "orderDetails": {
        "OWN": "Szczegóły zlecenia",
        "ANNEX": "Szczegóły zlecenia aneksu",
        "GUARANTEE_MODIFICATION": "Szczegóły modyfikacji gwarancji",
        "modificationType": {
          "RELEASE_GUARANTEE": "wcześniejsze zwolnienie",
          "PARTIAL_RELEASE": "częściowe zwolnienie",
          "RECALCULATE_PAYMENT_SCHEDULE": "zmiana harmonogramu"
        }
      },
      "annexNumber": "Nr aneksu",
      "status": "Status",
      "type": "Typ",
      "addressLabel": "Adres",
      "address": {
        "zipCode": "Kod pocztowy",
        "city": "Miasto",
        "voivodeship": "Województwo",
        "country": "Kraj",
        "line1": "Linia adresowa 1",
        "line2": "Linia adresowa 2",
        "line3": "Linia adresowa 3",
        "line4": "Linia adresowa 4"
      },
      "prevExpirationDate": "Pierwotna data ważności gwarancji",
      "newExpirationDate": "Nowa data ważności gwarancji",
      "modificationNumber": "Nr modyfikacji",
      "prevGuaranteeAmount": "Pierwotna kwota gwarancji",
      "newGuaranteeAmount": "Nowa kwota gwarancji",
      "scheduleChangedDate": "Data zmiany harmonogramu"
    },
    "content": {
      "safeguard": "Gwarancja w ramach",
      "creditLineId": "Linia kredytowa",
      "address": "Adres",
      "beneficiaryAddrAdditionalLine": "Linia adresowa",
      "guaranteeAmount": "Kwota",
      "amountAfterReduction": "Kwota po zredukowaniu",
      "guaranteeAmountWords": "Kwota słownie",
      "bankName": "Bank",
      "bankAddress": "Adres banku",
      "beneficiary": "Beneficjent",
      "beneficiaryAddrCity": "Miasto",
      "beneficiaryAddrCountryCode": "Kraj",
      "guaranteeCurrencyItem": "Waluta",
      "date": "Data",
      "reduction": "Redukcja",
      "guaranteeData": "Dane gwarancji",
      "guaranteeForm": "Formularz gwarancji",
      "formTemplateName": "Rodzaj",
      "customContent": "Treść niestandardowa",
      "message": {
        "saveFailed": "Zmiany nie zostały zapisane. Formularz zawiera błędy.",
        "validationFailed": "Walidacja się nie powiodła. Błędne pola zostały oznaczone w formularzu.",
        "validationFailedOnView": "Walidacja się nie powiodła. Przejdź do edycji, aby poprawić dane.",
        "validationSuccess": "Walidacja przebiegła pomyślnie"
      },
      "beneficiaryName": "Nazwa",
      "orderOrigin": "Źródło zlecenia",
      "reductionDueTo": "Redukcja z tytułu",
      "reductions": "Redukcje",
      "guaranteeWithin": "Gwarancja w ramach",
      "contractNumber": "Numer umowy",
      "beneficiaryAddrStreet": "Ulica",
      "effectiveDateOwn": "Data wystawienia gwarancji",
      "effectiveDateAnnex": "Data wystawienia aneksu",
      "effectiveDateGuarantee_modification": "Data wystawienia modyfikacji",
      "expirationDate": "Data ważności gwarancji",
      "beneficiaryAddrVoivodeship": "Województwo",
      "beneficiaryAddrZipCode": "Kod pocztowy",
      "creditLineWarningModal": "Wprowadzone parametry zlecenia są niezgodne z decyzją kredytową. Wystawienie gwarancji wymaga zgody banku."
    },
    "attachment": {
      "name": "Nazwa",
      "createdDate": "Data przesłania",
      "createdBy": "Użytkownik",
      "origin": "Strona przesyłająca",
      "guarantee": "Gwarancja",
      "annex": "Aneks",
      "other": "Pozostałe",
      "guarantees": "Gwarancje",
      "others": "Pozostałe",
      "annexes": "Aneksy gwarancji",
      "deleteSuccess": "Usunięto dokument",
      "modal": {
        "title": "Dodaj załącznik",
        "upload": "Dodaj plik",
        "uploadSuccess": "Dodawanie załącznika zakończone sukcesem",
        "deleteWarning": "Czy na pewno usunąć załącznik? Jeżeli istnieją poprzednie wersje załącznika, także zostaną usunięte."
      }
    },
    "childTab": {
      "buttons": {
        "preview": {
          "annex": "Podgląd aneksu",
          "modification": "Podgląd modyfikacji"
        }
      },
      "content": {
        "annexNumber": "Nr aneksu",
        "modificationNumber": "Nr modyfikacji",
        "id": "ID",
        "beneficiaryName": "Beneficjent",
        "guaranteeAmount": "Kwota",
        "formTemplateName": "Rodzaj",
        "status": "Status",
        "effectiveDate": "Data wystawienia",
        "expirationDate": "Data ważności",
        "lastModifiedDate": "Data modyfikacji",
        "operatorName": "Operator"
      }
    },
    "chatTab": {
      "noMessages": "Brak komentarzy",
      "send": "Wyślij"
    },
    "nav": {
      "formTab": "Formularz",
      "annexFormTab": "Zlecenie aneksu",
      "modificationFormTab": "Modyfikacja gwarancji",
      "attachments": "Załączniki",
      "payments": "Opłaty",
      "annexes": "Aneksy",
      "modifications": "Modyfikacje gwarancji",
      "projectsAndSignatures": "Projekty i podpisy",
      "chatTab": "Komentarze"
    },
    "buttons": {
      "action": {
        "name": "Akcje na zleceniu",
        "items": {
          "DELETE": "Usuń",
          "CANCEL": "Anuluj",
          "VERIFY": "Prześlij do weryfikacji",
          "SIGNING": "Prześlij do podpisu",
          "SIGN": "Podpisz",
          "READY_TO_COMPLETE": "Przekaż do realizacji",
          "RETURN_TO_DRAFT": "Wycofaj do edycji",
          "ANNEX": "Aneksuj"
        }
      },
      "copy": {
        "name": "Kopiuj zlecenie",
        "tooltip": "Złóż nowe zlecenie wykorzystując jako wzór zlecenie zrealizowane"
      },
      "generateDocuments": {
        "name": "Generowanie dokumentów",
        "items": {
          "ORDER_OWN": "Zlecenie gwarancji",
          "ORDER_ANNEX": "Zlecenie aneksu",
          "GUARANTEE_PROJECT": "Projekt gwarancji",
          "GUARANTEE_PROJECT_ADD": "Dodaj projekt do zlecenia",
          "ANNEX_PROJECT": "Projekt aneksu",
          "ANNEX_PROJECT_ADD": "Dodaj projekt do zlecenia"
        }
      }
    },
    "updateStatusModal": {
      "guarantee": {
        "CANCEL": {
          "title": "Anulowanie zlecenia",
          "text": "Zamierzasz anulować zlecenie. Zostanie naliczona opłata za obsługę. Czy chcesz kontynuować?"
        },
        "VERIFY": {
          "title": "Prześlij do weryfikacji",
          "text": "Zamierzasz przesłać zlecenie do weryfikacji w Banku. Czy chcesz kontynuować?"
        },
        "SIGNING": {
          "title": "Prześlij do podpisu",
          "text": "Zamierzasz przesłać zlecenie do podpisu. Czy chcesz kontynuować?"
        },
        "READY_TO_COMPLETE": {
          "title": "Przekaż do realizacji",
          "text": "Zamierzasz przesłać zlecenie do realizacji w Banku. Czy chcesz kontynuować?"
        },
        "RETURN_TO_DRAFT": {
          "title": "Wycofaj do edycji",
          "text": "Zamierzasz wycofać zlecenie do edycji, co spowoduje anulowanie złożonych na nim podpisów. Czy chcesz kontynuować?"
        }
      },
      "annex": {
        "CANCEL": {
          "title": "Anulowanie zlecenia aneksu",
          "text": "Zamierzasz anulować zlecenie aneksu. Zostanie naliczona opłata za obsługę. Czy chcesz kontynuować?"
        },
        "VERIFY": {
          "title": "Prześlij do weryfikacji",
          "text": "Zamierzasz przesłać zlecenie aneksu do weryfikacji w Banku. Czy chcesz kontynuować?"
        },
        "SIGNING": {
          "title": "Prześlij do podpisu",
          "text": "Zamierzasz przesłać zlecenie aneksu do podpisu. Czy chcesz kontynuować?"
        },
        "READY_TO_COMPLETE": {
          "title": "Przekaż do realizacji",
          "text": "Zamierzasz przesłać zlecenie aneksu do realizacji w Banku. Czy chcesz kontynuować?"
        },
        "RETURN_TO_DRAFT": {
          "title": "Wycofaj do edycji",
          "text": "Zamierzasz wycofać zlecenie aneksu do edycji, co spowoduje anulowanie złożonych na nim podpisów. Czy chcesz kontynuować?"
        }
      },
      "reason": "Przyczyna (opcjonalnie)",
      "guaranteeConfirmSaveModal": "Zmiany wprowadzone na zleceniu zostaną zapisane. Czy chcesz kontynuować?",
      "annexConfirmSaveModal": "Zmiany wprowadzone na zleceniu aneksu zostaną zapisane. Czy chcesz kontynuować?"
    },
    "deleteModal": {
      "title": "Usuń zlecenie",
      "text": "Zlecenie zostanie usunięte bez możliwości przywrócenia. Czy chcesz kontynuować?",
      "deleteSuccessText": "Zlecenie zostało usunięte"
    },
    "signOrderModal": {
      "guarantee": {
        "title": "Podpisz zlecenie",
        "text": "Zamierzasz złożyć podpis na zleceniu. Jeśli schemat podpisów zostanie spełniony, zlecenie zostanie przesłane do realizacji w Banku. Czy chcesz kontynuować?"
      },
      "annex": {
        "title": "Podpisz zlecenie aneksu",
        "text": "Zamierzasz złożyć podpis na zleceniu aneksu. Jeśli schemat podpisów zostanie spełniony, zlecenie aneksu zostanie przesłane do realizacji w Banku. Czy chcesz kontynuować?"
      },
      "signingSuccess": "Zlecenie zostało podpisane.",
      "signingSuccessAndOrderStatusChanged": "Zlecenie zostało podpisane, a następnie przekazane do realizacji w banku."
    },
    "paymentsTab": {
      "name": "Nazwa",
      "enName": "Nazwa",
      "newBaseAmount": "Kwota bazowa",
      "newBaseAmountAndCurrency": "Kwota i waluta bazowa",
      "paymentCurrency": "Waluta bazowa",
      "amount": "Kwota po przewalutowaniu",
      "accountCurrency": "Waluta",
      "account": "Rachunek WN",
      "paymentDate": "Data pobrania"
    },
    "projectsAndSignaturesTab": {
      "projects": {
        "sectionLabel": "Projekty",
        "currentVersion": "Obecna wersja projektu",
        "previousVersions": "Poprzednie wersje",
        "modal": {
          "title": {
            "OWN": "Dodaj projekt gwarancji",
            "ANNEX": "Dodaj projekt aneksu"
          },
          "uploadSuccess": "Dodawanie projektu zakończone sukcesem"
        },
        "content": {
          "attachmentVersion": "Nr wersji",
          "bankApproved": "Akceptacja banku",
          "clientApproved": "Akceptacja klienta",
          "confirmationInfoMessage": "Potwierdzone {{date}} przez {{userName}}",
          "creator": "Strona przesyłająca"
        },
        "warnings": {
          "acceptProject": {
            "OWN": "Zamierzasz zaakceptować projekt gwarancji. Czy chcesz kontynuować?",
            "ANNEX": "Zamierzasz zaakceptować projekt aneksu. Czy chcesz kontynuować?"
          },
          "withdrawProjectAcceptance": {
            "OWN": "Zamierzasz cofnąć akceptację projektu gwarancji. Czy chcesz kontynuować?",
            "ANNEX": "Zamierzasz cofnąć akceptację projektu aneksu. Czy chcesz kontynuować?"
          },
          "uploadProject": {
            "OWN": "Zamierzasz załączyć projekt gwarancji. Projekt zostanie automatycznie oznaczony jako zaakceptowany. Czy chcesz kontynuować?",
            "ANNEX": "Zamierzasz załączyć projekt aneksu. Projekt zostanie automatycznie oznaczony jako zaakceptowany. Czy chcesz kontynuować?"
          }
        }
      },
      "signs": {
        "sectionLabel": "Podpisy",
        "schemaFulfilled": "Schemat został spełniony",
        "schemaNotFulfilled": "Schemat nie został spełniony",
        "schema": {
          "fulfilledDate": "Data i czas",
          "fulfilledSchema": "Schemat",
          "orderSigns": "Złożone podpisy"
        }
      }
    },
    "previousValuesModal": {
      "text": "<strong>Wartości w poniższych polach formularza uległy zmianie:</strong> <br> {{labels}}"
    }
  },
  "previousValueTooltip": {
    "empty": "*pusta*",
    "previousValue": "Poprzednia wartość",
    "noSelected": "nie wybrano"
  },
  "guaranteePreviousValueTooltip": {
    "empty": "*pusta*",
    "previousValue": "Aneksowana wartość"
  }
}
